import React from 'react';

export default function(props) {
  if (props.if === undefined || props.if) {
    const newProps = { ...props };
    delete newProps.if;
    return <div {...newProps}>{props.children}</div>;
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/components_new/common/View.js